import { jsx as _jsx } from "react/jsx-runtime";
import { useModal } from '@phishtool/modal';
import { logEvent } from '@phishtool/analytics';
import { HeroButton } from '~components/hero/hero-button';
export const MSSPDemoButton = () => {
    const { openModal } = useModal();
    return (_jsx(HeroButton, { to: "#", onClick: (e) => {
            e.preventDefault();
            logEvent('Demo Requested', { source: 'mssp' });
            openModal('contact-sales');
        }, large: true, children: "Book an MSSP Demo" }));
};
